export const POSTHOG_BOOTSTRAP_DATA_COOKIE = "ph_bootstrap_data";
export const POSTHOG_REGION = "eu";

export const POSTHOG_API_HOST =
  process.env["NEXT_PUBLIC_POSTHOG_HOST"] ||
  `https://${POSTHOG_REGION}.i.posthog.com`;

export const POSTHOG_UI_HOST = `https://${POSTHOG_REGION}.posthog.com`;

export const POSTHOG_KEY = (
  process.env["NEXT_PUBLIC_VERCEL_ENV"] === "production"
    ? process.env["NEXT_PUBLIC_POSTHOG_KEY"]
    : process.env["NEXT_PUBLIC_POSTHOG_DEV_KEY"]
)!;
